import { useEffect, useState } from 'react';
import { getAiSearchAvailability } from '../../api';
import { useAuth } from '../../contexts/AuthContext';

/**
 * AI 검색을 이 계정에서 쓸 수 있는지 확인한다.
 *
 * 서버가 true를 준 경우에만 입구를 보여준다. 조회에 실패하면 없는 것으로 본다 —
 * 기능이 꺼져 있을 때와 화면이 같아야 밖에서 차이가 보이지 않는다.
 * @returns {{ available: boolean, checking: boolean }}
 */
export function useAiSearchAvailability() {
  const { isLoggedIn, role } = useAuth();
  const canAsk = isLoggedIn && role === 'PRODUCER';
  // null = 아직 답을 못 받음. checking을 따로 두면 canAsk가 막 true가 된 첫 렌더에서
  // '확인 끝, 못 씀'처럼 보여 호출하는 쪽이 키워드 목록을 먼저 불러 버린다.
  const [result, setResult] = useState(null); // { available: boolean } | null

  useEffect(() => {
    if (!canAsk) return undefined;
    let alive = true;
    getAiSearchAvailability()
      .then(value => { if (alive) setResult({ available: value }); })
      .catch(() => { if (alive) setResult({ available: false }); });
    return () => {
      alive = false;
      setResult(null);
    };
  }, [canAsk]);

  return {
    available: canAsk && Boolean(result?.available),
    checking: canAsk && result === null,
  };
}
